import React, { useEffect, useState } from "react";
import { fireStore } from '../../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';


const TravelReport = () => {

    const [logbooks, setLogbooks] = useState([]);

    useEffect(() => {
        const fetchLogbooks = async () => {
            try {
                const collectionRef = collection(fireStore, "LogBooks");
                const querySnapshot = await getDocs(collectionRef);

                const logbooksList = querySnapshot.docs.map((doc) => {
                    const docIdAsTimestamp = new Date(parseInt(doc.id, 10));
                    return {
                        id: doc.id,
                        timestamp: docIdAsTimestamp,
                        ...doc.data(),
                    };
                });

                const sortedLogbooksList = logbooksList.sort(
                    (a, b) => b.timestamp - a.timestamp
                );
                setLogbooks(sortedLogbooksList);
            } catch (error) {
                console.error("Error fetching logbooks:", error);
            }
        };

        fetchLogbooks();
    }, []);


    return (
        <div className="max-w-5xl mx-auto my-8 p-2 bg-white border shadow rounded-lg">
            <div className="grid grid-cols-3 gap-4 mb-4">
                <div>
                    <h3 className="font-semibold">Month:</h3>
                    <p>OCTOBER</p>
                </div>
                <div>
                    <h3 className="font-semibold">ABM/ZBM/HSM/CEO Name:</h3>
                    <p>Saleh Muhammad</p>
                </div>
                <div>
                    <h3 className="font-semibold">Vehicle:</h3>
                    <p>AXR-717</p>
                </div>
                <div>
                    <h3 className="font-semibold">Territory:</h3>
                    <p>Kamalia</p>
                </div>
            </div>

            {/* Table Section */}
            <table className="table-auto w-full border-collapse border border-gray-300 text-sm">
                <thead className="bg-gray-200">
                <tr>
                    <th className="border border-gray-300 p-2">Date</th>
                    <th className="border border-gray-300 p-2">Meter Reading</th>
                    <th className="border border-gray-300 p-2">Travelled KM</th>
                    <th className="border border-gray-300 p-2">Purpose of Travel (Area Visited)</th>
                    <th className="border border-gray-300 p-2">Fuel Qty (Ltr)</th>
                    <th className="border border-gray-300 p-2">Fuel Price (Rs.)</th>
                    <th className="border border-gray-300 p-2">Remarks</th>
                </tr>
                </thead>
                {logbooks?.length > 0 ? (
                    logbooks.map((logbook) => (
                    <tr key={logbook.id}>
                        <td className="border border-gray-300 p-2">
                            {logbook.timestamp.toISOString().split("T")[0]}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.meterReading || "N/A"}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.travelledKM || "N/A"}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.purposeOfTravel || "N/A"}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.fuelQuantity || "N/A"}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.fuelPrice || "N/A"}
                        </td>
                        <td className="border border-gray-300 p-2">
                            {logbook.remarks || "N/A"}
                        </td>
                    </tr>
                ))
                ) : (
                    <tr>
                        <td colSpan="7" className="text-center">No data available</td>
                    </tr>
                )
                }
                <tfoot>
                <tr className="font-semibold bg-gray-100">
                    <td className="border border-gray-300 p-2" colSpan="2">
                        TOTAL
                    </td>
                    <td className="border border-gray-300 p-2">
                        {logbooks.reduce(
                            (total, logbook) => total + (logbook.travelledKM || 0),
                            0
                        )}
                    </td>
                    <td className="border border-gray-300 p-2"></td>
                    <td className="border border-gray-300 p-2">
                        {logbooks.reduce(
                            (total, logbook) => total + (logbook.fuelQuantity || 0),
                            0
                        )}
                    </td>
                    <td className="border border-gray-300 p-2">
                        {logbooks.reduce(
                            (total, logbook) => total + (logbook.fuelPrice || 0),
                            0
                        )}
                    </td>
                    <td className="border border-gray-300 p-2"></td>
                </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default TravelReport;
